export const SET_SHOW_NOTIFICATION = 'SET_SHOW_NOTIFICATION'
export const GET_SHOW_NOTIFICATION = 'GET_SHOW_NOTIFICATION'

const initialState = {
  show: false,
  error: '',
  message: '',
}

export const showNotification = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHOW_NOTIFICATION: {
      const { show, error, message } = action
      return Object.assign({}, state, { show, error, message })
    }
    case GET_SHOW_NOTIFICATION: {
      return state
    }
    default: {
      return state
    }
  }
}
